"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ow_1 = require("ow");

var Remarkable = require("remarkable");

var SecurityChecker_1 = require("../../security/SecurityChecker");

var DefaultRendererLocalization_1 = require("./DefaultRendererLocalization");

var AssetEmbedder_1 = require("./embedder/AssetEmbedder");

var PreliminarySanitizer_1 = require("./sanitization/PreliminarySanitizer");

var TagTransformingSanitizer_1 = require("./sanitization/TagTransformingSanitizer");

var DefaultRenderer =
/*#__PURE__*/
function () {
  function DefaultRenderer(options) {
    var localization = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultRendererLocalization_1.DefaultRendererLocalization.DEFAULT;

    _classCallCheck(this, DefaultRenderer);

    DefaultRenderer.Options.validate(options);
    this.options = options;
    DefaultRendererLocalization_1.DefaultRendererLocalization.validate(localization);
    this.tagTransformingSanitizer = new TagTransformingSanitizer_1.TagTransformingSanitizer({
      iframeWidth: this.options.assetsWidth,
      iframeHeight: this.options.assetsHeight,
      addNofollowToLinks: this.options.addNofollowToLinks,
      noImage: this.options.doNotShowImages,
      isLinkSafeFn: this.options.isLinkSafeFn
    }, localization);
    this.embedder = new AssetEmbedder_1.AssetEmbedder({
      ipfsPrefix: this.options.ipfsPrefix,
      width: this.options.assetsWidth,
      height: this.options.assetsHeight,
      hideImages: this.options.doNotShowImages,
      imageProxyFn: this.options.imageProxyFn,
      hashtagUrlFn: this.options.hashtagUrlFn,
      usertagUrlFn: this.options.usertagUrlFn,
      baseUrl: this.options.baseUrl
    }, localization);
  }

  _createClass(DefaultRenderer, [{
    key: "render",
    value: function render(input) {
      ow_1.default(input, "input", ow_1.default.string.nonEmpty);
      return this.doRender(input);
    }
  }, {
    key: "doRender",
    value: function doRender(text) {
      text = PreliminarySanitizer_1.PreliminarySanitizer.preliminarySanitize(text);
      var isHtml = this.isHtml(text);
      text = isHtml ? text : this.renderMarkdown(text);
      text = this.wrapRenderedTextWithHtmlIfNeeded(text);
      text = this.embedder.markAssets(text);
      text = this.sanitize(text);
      SecurityChecker_1.SecurityChecker.checkSecurity(text, {
        allowScriptTag: this.options.allowInsecureScriptTags
      });
      text = this.embedder.insertAssets(text);
      return text;
    }
  }, {
    key: "renderMarkdown",
    value: function renderMarkdown(text) {
      var renderer = new Remarkable({
        html: true,
        breaks: this.options.breaks,
        linkify: false,
        typographer: false,
        quotes: "“”‘’"
      });
      return renderer.render(text);
    }
  }, {
    key: "wrapRenderedTextWithHtmlIfNeeded",
    value: function wrapRenderedTextWithHtmlIfNeeded(renderedText) {
      // If content isn't wrapped with an html element at this point, add it.
      if (renderedText.indexOf("<html>") !== 0) {
        renderedText = "<html>" + renderedText + "</html>";
      }

      return renderedText;
    }
  }, {
    key: "isHtml",
    value: function isHtml(text) {
      var html = false; // See also ReplyEditor isHtmlTest

      var m = text.match(/^<html>([\S\s]*)<\/html>$/);

      if (m && m.length === 2) {
        html = true;
        text = m[1];
      } else {
        // See also ReplyEditor isHtmlTest
        html = /^<p>[\S\s]*<\/p>/.test(text);
      }

      return html;
    }
  }, {
    key: "sanitize",
    value: function sanitize(text) {
      if (this.options.skipSanitization) {
        return text;
      }

      return this.tagTransformingSanitizer.sanitize(text);
    }
  }]);

  return DefaultRenderer;
}();

exports.DefaultRenderer = DefaultRenderer;

(function (DefaultRenderer) {
  var Options;

  (function (Options) {
    function validate(o) {
      ow_1.default(o.baseUrl, "Options.baseUrl", ow_1.default.string.nonEmpty);
      ow_1.default(o.breaks, "Options.breaks", ow_1.default.boolean);
      ow_1.default(o.skipSanitization, "Options.skipSanitization", ow_1.default.boolean);
      ow_1.default(o.addNofollowToLinks, "Options.addNofollowToLinks", ow_1.default.boolean);
      ow_1.default(o.doNotShowImages, "Options.doNotShowImages", ow_1.default.boolean);
      ow_1.default(o.ipfsPrefix, "Options.ipfsPrefix", ow_1.default.string);
      ow_1.default(o.assetsWidth, "Options.assetsWidth", ow_1.default.number.integer.positive);
      ow_1.default(o.assetsHeight, "Options.assetsHeight", ow_1.default.number.integer.positive);
      ow_1.default(o.imageProxyFn, "Options.imageProxyFn", ow_1.default.function);
      ow_1.default(o.hashtagUrlFn, "Options.hashtagUrlFn", ow_1.default.function);
      ow_1.default(o.usertagUrlFn, "Options.usertagUrlFn", ow_1.default.function);
      ow_1.default(o.isLinkSafeFn, "TagTransformingSanitizer.Options.isLinkSafeFn", ow_1.default.function);
    }

    Options.validate = validate;
  })(Options = DefaultRenderer.Options || (DefaultRenderer.Options = {}));
})(DefaultRenderer = exports.DefaultRenderer || (exports.DefaultRenderer = {}));